<template>
  <div>
    <div class="sk-header flex justify-end items-center">
      <div class="w-64">
        <div class="flex justify-between">
          <div class="flex flex-col justify-center items-end pr-2">
            <span class="sk-line h-4 mb-2 w-full"></span>
            <span class="sk-line h-4 w-2/3"></span>
          </div>
          <span
              class="sk-header-avatar relative rounded-full overflow-hidden"
          ></span>
        </div>
      </div>
    </div>
    <div class="w-full flex justify-center pt-12">
      <div class="w-4/5">
        <div class="flex">
          <div
              class="bg-zt-dark-200 rounded-zt-sm flex justify-center pt-8"
              style="height: 450px; flex-basis: 20%; flex-grow: 0; flex-shrink: 0"
          >
            <span
                class="sk-info-avatar relative overflow-hidden rounded-full"
            ></span>
          </div>
          <div class=" pl-8 w-full">
            <div
                class="w-full rounded-zt-sm p-4 h-24 bg-white flex flex-col mb-4"
            >
              <span class="sk-line-alter h-8 w-1/2 mb-2"></span>
              <span class="sk-line-alter h-5 w-4/5"></span>
            </div>
            <div
                class="w-full rounded-zt-sm p-4 h-24 bg-white flex flex-col mb-4"
            >
              <span class="sk-line-alter h-8 w-2/3 mb-2"></span>
              <span class="sk-line-alter h-5 w-11/12 mb-2"></span>
              <span class="sk-line-alter h-5 w-4/5"></span>
            </div>
            <div class="w-full rounded-zt-sm py-6 bg-white">
              <div class="flex">
                <div class="w-48 h-12 border-b-4 border-r">
                  <span class="sk-line-alter block w-32 h-8 m-auto"></span>
                </div>
                <div class="w-48 h-12 border-b-4">
                  <span class="sk-line-alter block w-32 h-8 m-auto"></span>
                </div>
              </div>
              <div class="border-b h-24 flex items-center py-4 px-8">
                <div class="w-48">
                  <div class="flex justify-between">
                    <div class="flex flex-col">
                      <span class="sk-line-alter w-1/2 h-4 mb-2"></span>
                      <span class="sk-line-alter w-3/2 h-4"></span>
                    </div>
                    <span
                        class="sk-bh-avatar ml-10 rounded-full h-10 w-10 bg-zt-dark-200 relative overflow-hidden"
                    ></span>
                  </div>
                </div>
              </div>
              <div class="border-b h-24 flex items-center py-4 px-8">
                <div class="w-48">
                  <div class="flex justify-between">
                    <div class="flex flex-col">
                      <span class="sk-line-alter w-1/2 h-4 mb-2"></span>
                      <span class="sk-line-alter w-3/2 h-4"></span>
                    </div>
                    <span
                        class="sk-bh-avatar ml-10 rounded-full h-10 w-10 bg-zt-dark-200 relative overflow-hidden"
                    ></span>
                  </div>
                </div>
              </div>
              <div class="border-b h-24 flex items-center py-4 px-8">
                <div class="w-48">
                  <div class="flex justify-between">
                    <div class="flex flex-col">
                      <span class="sk-line-alter w-1/2 h-4 mb-2"></span>
                      <span class="sk-line-alter w-3/2 h-4"></span>
                    </div>
                    <span
                        class="sk-bh-avatar ml-10 rounded-full h-10 w-10 bg-zt-dark-200 relative overflow-hidden"
                    ></span>
                  </div>
                </div>
              </div>
              <div class="border-b h-24 flex items-center py-4 px-8">
                <div class="w-48">
                  <div class="flex justify-between">
                    <div class="flex flex-col">
                      <span class="sk-line-alter w-1/2 h-4 mb-2"></span>
                      <span class="sk-line-alter w-3/2 h-4"></span>
                    </div>
                    <span
                        class="sk-bh-avatar ml-10 rounded-full h-10 w-10 bg-zt-dark-200 relative overflow-hidden"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "skeletonAuthSSO"
}
</script>

<style lang="scss" scoped>
.sk-header {
  width: 100%;
  height: 4.469rem;
  margin: 0 0.006rem 0 0;
  padding: 0 3.722rem 0 0;
  box-shadow: 0 4px 4px 0 rgba(150, 150, 150, 0.1);
  background-color: #ffffff;
}
.sk-header-avatar {
  background-color: #c4c4c4;
  width: 50px;
  height: 50px;
}
.sk-header-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-info-avatar {
  background-color: #c4c4c4;
  width: 80px;
  height: 80px;
}
.sk-info-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-bh-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-line {
  background-color: #c4c4c4;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
}
.sk-line::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-line-alter {
  background-color: #dedede;
  overflow: hidden;
  position: relative;
  border-radius: 5px;
}
.sk-line-alter::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}
</style>
